import React, { useState } from 'react';
import ProjectRow from './ProjectRow';

function ProjectTable({
  activities,
  onEditInline,
  onEditChange,
  onEditSave,
  onDeleteSelected,
  onDuplicateSelected,
  onAddActivity,
  onActivityDrag // função passada pelo ProjectView para reordenar atividades
}) {
  const [selected, setSelected] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const [newActivity, setNewActivity] = useState({
    title: '',
    status: 'Pendente',
    responsible: 'Escritório',
    plannedEnd: '',
    dataConclusao: '',
    comments: []
  });

  const toggleSelect = (activity) => {
    setSelected(s =>
      s.includes(activity)
        ? s.filter(a => a !== activity)
        : [...s, activity]
    );
  };

  const handleDeleteSelected = () => {
    if (onDeleteSelected) onDeleteSelected(selected);
    setSelected([]);
  };

  const handleDuplicateSelected = () => {
    if (onDuplicateSelected) onDuplicateSelected(selected);
    setSelected([]);
  };

  const startAdding = () => setIsAdding(true);

  const updateNew = (field, value) =>
    setNewActivity(a => ({ ...a, [field]: value }));

  const saveNew = () => {
    if (!newActivity.title.trim()) return;
    if (onAddActivity) onAddActivity(newActivity);
    setNewActivity({
      title: '',
      status: 'Pendente',
      responsible: 'Escritório',
      plannedEnd: '',
      dataConclusao: '',
      comments: []
    });
    setIsAdding(false);
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center space-x-2">
        {onAddActivity && (
          <button
            onClick={startAdding}
            className="bg-[#b29d92] hover:bg-[#b29d92] text-white px-3 py-1 rounded"
            type="button"
          >
            + Adicionar Atividade
          </button>
        )}

        {selected.length > 0 && (
          <div className="flex space-x-2">
            {onDeleteSelected && (
              <button
                onClick={handleDeleteSelected}
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                type="button"
              >
                Excluir Selecionadas
              </button>
            )}
            {onDuplicateSelected && (
              <button
                onClick={handleDuplicateSelected}
                className="bg-gray-500 hover:bg-gray-600 text-white px-3 py-1 rounded"
                type="button"
              >
                Duplicar Selecionadas
              </button>
            )}
          </div>
        )}
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full table-auto border-collapse border border-gray-300">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 border">
                <input
                  type="checkbox"
                  checked={selected.length === activities.length && activities.length > 0}
                  onChange={() =>
                    setSelected(
                      selected.length === activities.length ? [] : activities
                    )
                  }
                />
              </th>
              <th className="p-2 border text-left">Notas</th>
              <th className="p-2 border text-left">Atividade</th>
              <th className="p-2 border text-left">Situação</th>
              <th className="p-2 border text-left">Responsável</th>
              <th className="p-2 border text-left">Término Previsto</th>
              <th className="p-2 border text-left">Término Real</th>
            </tr>
          </thead>

          <tbody>
            {activities.map((activity, idx) => (
              <ProjectRow
                key={idx}
                index={idx}
                activity={activity}
                onEditInline={onEditInline}
                onEditChange={onEditChange}
                onEditSave={onEditSave}
                isSelected={selected.includes(activity)}
                onSelectToggle={toggleSelect}
                editable={Boolean(onEditInline)}
                onReorder={onActivityDrag} // função que recebe (stageId, fromIndex, toIndex)
              />
            ))}

            {isAdding && onAddActivity && (
              <tr className="border-b bg-yellow-50">
                <td className="p-2"></td>
                <td className="p-2"></td>
                <td className="p-2">
                  <input
                    type="text"
                    value={newActivity.title}
                    onChange={e => updateNew('title', e.target.value)}
                    className="border rounded px-1 w-full"
                    placeholder="Atividade"
                  />
                </td>
                <td className="p-2">
                  <select
                    value={newActivity.status}
                    onChange={e => updateNew('status', e.target.value)}
                    className="border rounded w-full"
                  >
                    <option>Pendente</option>
                    <option>Em andamento</option>
                    <option>Concluído</option>
                  </select>
                </td>
                <td className="p-2">
                  <select
                    value={newActivity.responsible || ''}
                    onChange={e => updateNew('responsible', e.target.value)}
                    className="border rounded w-full"
                  >
                    <option value="">Selecione</option>
                    <option value="Escritório">Escritório</option>
                    <option value="Cliente">Cliente</option>
                  </select>
                </td>
                <td className="p-2">
                  <input
                    type="date"
                    value={newActivity.plannedEnd}
                    onChange={e => updateNew('plannedEnd', e.target.value)}
                    className="border rounded px-1 w-full"
                  />
                </td>
                <td className="p-2">
                  <button
                    onClick={saveNew}
                    className="bg-green-500 hover:bg-green-600 text-white px-2 py-1 rounded text-sm"
                    type="button"
                  >
                    Salvar
                  </button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ProjectTable;
